import * as actionTypes from "./actionTypes";

export const submitNeedAssistanceData = payload => ({
  type: actionTypes.submitNeedAssistanceDataType,
  payload
});

export const showAssistanceComponent = payload => ({
  type: actionTypes.showAssistanceComponentType,
  payload
});

export const showAssistanceDone = payload => ({
  type: actionTypes.showAssistanceDoneType,
  payload
});
